import 'react-slideshow-image/dist/styles.css';

import { Fade } from 'react-slideshow-image';
import React from 'react';

const HomeBanner = ({ pullmanBanners }) => {
  let bannerImageEn = [];
  let bannerImageEs = [];

  if (pullmanBanners) {
    pullmanBanners &&
      pullmanBanners.en.forEach(item => {
        bannerImageEn.push({ url: item });
      });
    pullmanBanners &&
      pullmanBanners.es.forEach(item => {
        bannerImageEs.push({ url: item });
      });
  }

  const fadeProperties = {
    duration: 5000,
    pauseOnHover: false,
    autoplay: true,
    prevArrow: (
      <button className="home-banner-prevArrow">
        <img className="home-banner-arrow" src="/images/HomeBanner/Home-LeftArrow.svg" alt="" />
      </button>
    ),
    nextArrow: (
      <button className="home-banner-nextArrow">
        <img className="home-banner-arrow" src="/images/HomeBanner/Home-RightArrow.svg" alt="" />
      </button>
    ),
  };

  const currentLangImage = () => {
    if (localStorage.getItem('selectedLanguage') === 'en') return bannerImageEn;
    else return bannerImageEs;
  };

  return (
    <div className="home-banner">
      <Fade {...fadeProperties}>
        {currentLangImage().map((fadeImage, index) => (
          <div className="each-fade" key={index}>
            <a href={index === 0 ? 'https://pullman.cl/' : ''} target="_blank">
              <div className="image-container">
                <img src={fadeImage.url} />
              </div>
            </a>
          </div>
        ))}
      </Fade>
    </div>
  );
};

export default HomeBanner;



// WEBPACK FOOTER //
// ./src/features/home/HomeBanner/HomeBanner.js